import {Injectable} from "@angular/core";


@Injectable({
    providedIn: 'root',
})
export class SharedService {
    private userData: any;

    setUserData(data: any): void {
        this.userData = data;
    }

    setLanguageData(data: boolean): void {
        localStorage.setItem('languageLocale', data.toString());
    }

    getLanguageData(): any {
        const data = localStorage.getItem('languageLocale') === 'true';
        return data ? data : null;
    }

    getUserData(): any {
        return this.userData;
    }

}
